<div class="shadow bg-white fixed top-0 z-50 w-full">
    <div class="text-black">
        <div class="grid grid-cols-12 items-center">
            <!-- Logo -->
            <div class="col-span-6 sm:col-span-2">
                <img [routerLink]="'/'" src="assets/image/header-img/paiu-logo.jpg" alt="Logo" class="w-60"/>
            </div>

            <!-- Hamburger Icon for Mobile -->
            <div class="col-span-6 sm:hidden flex justify-end pr-4">
                <button (click)="toggleMobileMenu()" class="text-gray-700 text-2xl focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                         class="w-8 h-8">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 6h16M4 12h16m-7 6h7"/>
                    </svg>
                </button>
            </div>

            <!-- Desktop Menu -->
            <div class="col-span-10 hidden sm:flex menu items-center justify-end">
                <ul class="flex gap-6 px-5">
                    <li class="px-3 dropdown pt-[2px]">
                        <button class="text-gray-700 flex items-center text-sm font-bold">
                            About
                            <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                 fill="currentColor">
                                <path fill-rule="evenodd"
                                      d="M5.293 7.707a1 1 0 011.414 0L10 11.414l3.293-3.707a1 1 0 011.414 0z"
                                      clip-rule="evenodd"/>
                            </svg>
                        </button>
                        <div
                            class="dropdown-content "
                        >
                            <ul class="py-1">
                                <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                    <a [routerLink]="'about'">
                                        About PAIU
                                    </a>
                                </li>
                                <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                    <a [routerLink]="'about/recognition'">
                                        Recognition
                                    </a>
                                </li>
                                <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                    <a [routerLink]="'about/affiliate-partners'">
                                        Affiliate & Partners
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li class="dropdown pt-[2px]">
                        <button
                            class="text-gray-700 items-center flex text-sm font-bold"
                        >
                            Our Programs
                            <svg
                                class="-mr-1 ml-2 h-5 w-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M5.293 7.707a1 1 0 011.414 0L10 11.414l3.293-3.707a1 1 0 011.414 0z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                        </button>
                        <div
                            class="dropdown-content "
                        >
                            <ul class="py-1">
                                <li class="submenu w-full text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                    Bachelor Program
                                    <ul class="submenu-content">
                                        <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                            BBA
                                        </li>
                                        <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                            Finance
                                        </li>
                                        <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                            Hospitality & Tourism
                                        </li>
                                    </ul>
                                </li>

                                <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                    Master Program
                                </li>
                                <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                    PHD Program
                                </li>
                                <li class="text-gray-700 block px-4 py-2 text-sm hover:bg-gray-100">
                                    DBA Program
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li><a [routerLink]="'application-process'" class="text-gray-700 text-sm font-bold">Application
                        Process</a></li>
                    <li><a [routerLink]="'contact-us'" class="text-gray-700 text-sm font-bold">Contact Us</a></li>
                    <li><a [routerLink]="'login'" class="text-gray-700 text-sm font-bold">Login</a></li>
                    <li (click)="openModal()"><a  class=" cursor-pointer text-gray-700 text-sm font-bold">Apply Now</a></li>
                </ul>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Menu -->
<div
    class="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-end sm:hidden"
    *ngIf="isMobileMenuOpen"
>
    <div class="bg-white w-2/3 h-full transform transition-transform duration-300 ease-in-out"
         [ngClass]="{'translate-x-0': isMobileMenuOpen, 'translate-x-full': !isMobileMenuOpen}">
        <div class="p-4">
            <button (click)="toggleMobileMenu()" class="text-gray-700 text-2xl focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                     class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
        </div>
        <ul class="flex flex-col gap-6 px-5 pt-8">
            <li><a [routerLink]="'about'" class="text-gray-700 text-sm font-bold">About</a></li>
            <li><a [routerLink]="'application-process'" class="text-gray-700 text-sm font-bold">Application Process</a>
            </li>
            <li><a [routerLink]="'contact-us'" class="text-gray-700 text-sm font-bold">Contact Us</a></li>
            <li><a [routerLink]="'login'" class="text-gray-700 text-sm font-bold">Login</a></li>
            <li><a  (click)="closeModal()" class="text-gray-700 text-sm font-bold">Apply Now</a></li>
        </ul>
    </div>
</div>


<!-- Modal -->
<div *ngIf="isModalOpen"
     class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 transition-opacity duration-500"
     [ngClass]="{'opacity-100': isModalVisible, 'opacity-0': !isModalVisible}"
     (transitionend)="onTransitionEnd()">
    <div class="rounded-lg shadow-lg w-[90%] md:w-[50%] transform transition-all duration-500 ease-in-out"
         [ngClass]="{'scale-100 opacity-100 translate-y-0': isModalVisible, 'scale-95 opacity-0 translate-y-10': !isModalVisible}">

        <!-- Modal Header -->
        <div class="bg-[#36348e] flex justify-between items-center rounded-t-lg px-4 py-3">
            <h2 class="text-xl text-white font-semibold">Register Now To Apply
                Get details and latest updates and many more!</h2>
            <button (click)="closeModal()"
                    class="text-white text-xl px-4 py-2 rounded hover:text-red-600">
                <i class="fa fa-close"></i>
            </button>
        </div>

        <!-- Modal Body -->
        <div class="bg-white p-6 rounded-b-lg">
            <app-form (formSubmitted)="formSubmission($event)"></app-form>
        </div>
    </div>
</div>
